import { base } from 'api';
import { SearchUserQueryType, UserUpdateType } from 'types';

const PATH = '/users';

const get = (id: string) => base.get(`${PATH}/${id}`);

const getAll = (filter: SearchUserQueryType) =>
  base.get(PATH, { params: { ...filter } });

const put = (updateData: UserUpdateType) =>
  base.put(`${PATH}/${updateData.id}`, updateData);

export { get, getAll, put };
